import CheckoutPayPalButton from "components/checkout/CheckoutPayPalButton";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutStripeForm from "components/checkout/CheckoutStripeForm";
import { memo, useEffect, useState } from "react";
import Radio from "@/atoms/Radio";
import styled from "styled-components";
import { assetUrl } from "utils";
import CollapsibleContainer from "@/atoms/CollapsibleContainer";
import Highlight from "@/atoms/account/Highlight";

const stripePromise = loadStripe(
  process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY
);

const CustomRadio = styled(Radio)`
  background-color: transparent;
`;

const RadioContainer = ({ children, selected }) => (
  <div
    className={`bg-perriwinkle rounded-lg p-2 ${
      selected
        ? "bg-opacity-10 text-perriwinkle transition-colors duration-300 ease-in-out"
        : "bg-opacity-0 text-textGray-lighter"
    }`}
  >
    {children}
  </div>
);

const StyledPaypalButton = styled(CheckoutPayPalButton)`
  ${({ theme }) => theme.media["sm"]} {
    .btn-wrapper {
      display: ${(props) => (props.inline ? "flex" : "block")};
      justify-content: flex-end;

      #paypal-button {
        min-width: ${(props) => (props.inline ? "320px" : "100%")};
      }
    }
  }
`;

const StyledStripeForm = styled(CheckoutStripeForm)`
  button {
    margin-bottom: 0;
  }
  ${({ theme }) => theme.media["sm"]} {
    .btn-wrapper {
      display: ${(props) => (props.inline ? "flex" : "block")};
      justify-content: flex-end;
    }
  }
`;

const EditBilling = memo(({ errorMsg, onToken, inline, buttonLabel }) => {
  const [paymentType, setPaymentType] = useState("stripe");
  const [error, setError] = useState();
  const onChangeType = (e) => setPaymentType(e.target.value);
  const handleToken = ({ token: paymentToken }) =>
    onToken({ paymentToken, paymentType });
  const onError = (errorMsg) => setError(errorMsg);

  useEffect(() => {
    errorMsg && setError(errorMsg);
  }, [errorMsg]);

  return (
    <div>
      {error && (
        <Highlight error className={"mb-4"}>
          {error}
        </Highlight>
      )}
      <div className={"flex flex-wrap gap-4 mb-4"}>
        <RadioContainer selected={paymentType === "stripe"}>
          <CustomRadio
            withCheckmark
            value={"stripe"}
            name={"payment-method-type"}
            onChange={onChangeType}
            defaultChecked={paymentType === "stripe"}
            selectedValue={paymentType}
            label={
              <div className="flex justify-between items-center  pr-4 w-full">
                <span className={"whitespace-nowrap mr-4"}>Credit Card</span>
                <img
                  src={assetUrl("/static/img/credit-cards.svg")}
                  alt="visa, mastercard, amex, discover"
                  width={110}
                />
              </div>
            }
          />
        </RadioContainer>
        <RadioContainer selected={paymentType === "paypal"}>
          <CustomRadio
            withCheckmark
            value={"paypal"}
            name={"payment-method-type"}
            onChange={onChangeType}
            defaultChecked={paymentType === "paypal"}
            selectedValue={paymentType}
            label={
              <div className="flex items-center">
                <img
                  src={assetUrl("/static/img/paypal-logo-letters.svg")}
                  alt="PayPal"
                  width={17}
                  className={"mr-2 flex-shrink-0"}
                />
                <span>PayPal</span>
              </div>
            }
          />
        </RadioContainer>
      </div>
      <CollapsibleContainer expanded={paymentType === "stripe"}>
        <Elements stripe={stripePromise}>
          <StyledStripeForm
            paymentButtonLabel={buttonLabel}
            fieldLabel={"Credit Card"}
            inline={inline}
            onError={onError}
            onToken={handleToken}
          />
        </Elements>
      </CollapsibleContainer>
      <CollapsibleContainer expanded={paymentType === "paypal"}>
        <StyledPaypalButton
          hideTotal={true}
          inline={inline}
          onError={onError}
          onToken={handleToken}
        />
      </CollapsibleContainer>
    </div>
  );
});

export default EditBilling;
